import { render, staticRenderFns } from "./hzyc.vue?vue&type=template&id=38cd4580&scoped=true"
import script from "./hzyc.vue?vue&type=script&lang=js"
export * from "./hzyc.vue?vue&type=script&lang=js"
import style0 from "./hzyc.vue?vue&type=style&index=0&id=38cd4580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cd4580",
  null
  
)

export default component.exports